// @ts-nocheck
(function () {
  const MOBILE_MAX_WIDTH = 749;
  const SECTION_VISIBLE_THRESHOLD = 0.2;
  const MOBILE_CARD_VISIBLE_THRESHOLD = 0.5;

  function isMobileView() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX_WIDTH + 'px)').matches;
  }

  function getCardVideo(card) {
    return card.querySelector('.video-grid-card__video');
  }

  function showPoster(card) {
    card.classList.remove('is-video-playing');
    const video = getCardVideo(card);
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  }

  function playVideo(card) {
    const video = getCardVideo(card);
    if (!video) return;

    video.loop = isMobileView();

    if (video.readyState === 0) {
      video.load();
    }

    card.classList.add('is-video-playing');
    video.play().catch(function () {});
  }

  function initVideoGridSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.videoGridInit === 'true') return;
    sectionEl.dataset.videoGridInit = 'true';

    const cards = Array.from(sectionEl.querySelectorAll('[data-video-grid-card]'));
    const abortController = new AbortController();
    const signal = abortController.signal;

    let sectionObserver = null;
    let cardObserver = null;
    let sectionVisible = false;
    let sequenceInterrupted = false;
    let hoveredCard = null;
    const mobileVisibleCards = new Set();

    function pauseAllCards() {
      cards.forEach(showPoster);
    }

    function playSingleCard(targetCard) {
      cards.forEach(function (card) {
        if (card === targetCard) {
          playVideo(card);
        } else {
          showPoster(card);
        }
      });
    }

    function startDesktopSequence() {
      if (!sectionVisible || isMobileView() || cards.length === 0) return;

      sequenceInterrupted = false;
      hoveredCard = null;
      pauseAllCards();
      playSingleCard(cards[0]);
    }

    function handleDesktopVideoEnded(card) {
      if (isMobileView() || !sectionVisible) return;

      const cardIndex = cards.indexOf(card);
      showPoster(card);

      if (sequenceInterrupted) {
        if (hoveredCard !== card) return;
        hoveredCard = null;
        sequenceInterrupted = false;
      }

      const nextIndex = cardIndex + 1;
      if (nextIndex < cards.length) {
        playSingleCard(cards[nextIndex]);
      } else {
        startDesktopSequence();
      }
    }

    function handleDesktopCardHover(card) {
      if (isMobileView()) return;

      if (card.classList.contains('is-video-playing')) return;

      sequenceInterrupted = true;
      hoveredCard = card;
      playSingleCard(card);
    }

    function handleSectionVisibility(isVisible) {
      sectionVisible = isVisible;

      if (isMobileView()) return;

      if (isVisible) {
        startDesktopSequence();
      } else {
        sequenceInterrupted = false;
        hoveredCard = null;
        pauseAllCards();
      }
    }

    function syncMobilePlayback() {
      cards.forEach(function (card) {
        if (mobileVisibleCards.has(card)) {
          playVideo(card);
        } else {
          showPoster(card);
        }
      });
    }

    function syncDesktopPlayback() {
      if (sectionVisible) {
        startDesktopSequence();
      } else {
        pauseAllCards();
      }
    }

    function syncPlayback() {
      if (isMobileView()) {
        syncMobilePlayback();
      } else {
        syncDesktopPlayback();
      }
    }

    function disconnectObservers() {
      if (sectionObserver) {
        sectionObserver.disconnect();
        sectionObserver = null;
      }

      if (cardObserver) {
        cardObserver.disconnect();
        cardObserver = null;
      }
    }

    function setupObservers() {
      disconnectObservers();

      if (isMobileView()) {
        sectionVisible = false;
        sequenceInterrupted = false;
        hoveredCard = null;

        cardObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              const card = entry.target;
              if (entry.isIntersecting) {
                mobileVisibleCards.add(card);
              } else {
                mobileVisibleCards.delete(card);
                showPoster(card);
              }
            });

            syncMobilePlayback();
          },
          {
            root: null,
            threshold: MOBILE_CARD_VISIBLE_THRESHOLD,
            rootMargin: '0px',
          }
        );

        cards.forEach(function (card) {
          cardObserver.observe(card);
        });
      } else {
        mobileVisibleCards.clear();

        sectionObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              handleSectionVisibility(entry.isIntersecting);
            });
          },
          {
            root: null,
            threshold: SECTION_VISIBLE_THRESHOLD,
            rootMargin: '0px',
          }
        );

        sectionObserver.observe(sectionEl);
      }
    }

    cards.forEach(function (card) {
      const video = getCardVideo(card);
      if (!video) return;

      video.addEventListener(
        'ended',
        function () {
          handleDesktopVideoEnded(card);
        },
        { signal: signal }
      );

      card.addEventListener(
        'mouseenter',
        function () {
          handleDesktopCardHover(card);
        },
        { signal: signal }
      );
    });

    sectionEl.videoGridResetPlayback = function () {
      mobileVisibleCards.clear();
      sequenceInterrupted = false;
      hoveredCard = null;
      pauseAllCards();

      if (isMobileView()) {
        syncMobilePlayback();
      }
    };

    sectionEl.videoGridSyncPlayback = syncPlayback;

    sectionEl.videoGridDestroy = function () {
      abortController.abort();
      disconnectObservers();
      mobileVisibleCards.clear();
      pauseAllCards();
      delete sectionEl.dataset.videoGridInit;
      delete sectionEl.videoGridResetPlayback;
      delete sectionEl.videoGridSyncPlayback;
      delete sectionEl.videoGridDestroy;
    };

    let resizeTimer;
    window.addEventListener(
      'resize',
      function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          setupObservers();
          syncPlayback();
        }, 150);
      },
      { signal: signal }
    );

    setupObservers();
  }

  function initVideoGridSwiper(sectionEl) {
    if (!sectionEl || typeof Swiper === 'undefined') return;

    const swiperEl = sectionEl.querySelector('.video-grid-swiper');
    if (!swiperEl) return;

    if (swiperEl.swiper && typeof swiperEl.swiper.destroy === 'function') {
      swiperEl.swiper.destroy(true, true);
    }

    if (swiperEl.dataset.swiperInit === 'true') {
      delete swiperEl.dataset.swiperInit;
    }

    swiperEl.dataset.swiperInit = 'true';

    const paginationEl = swiperEl.querySelector('.video-grid-swiper__pagination');
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.3,
      spaceBetween: 0,
      slidesPerGroup: 1,
      breakpoints: {
        400: {
          slidesPerView: 1.347,
          spaceBetween: 0,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,
    });

    swiper.on('slideChange', function () {
      if (isMobileView()) {
        if (typeof sectionEl.videoGridSyncPlayback === 'function') {
          sectionEl.videoGridSyncPlayback();
        }
        return;
      }

      if (typeof sectionEl.videoGridResetPlayback === 'function') {
        sectionEl.videoGridResetPlayback();
      } else {
        sectionEl.querySelectorAll('[data-video-grid-card].is-video-playing').forEach(showPoster);
      }

      if (typeof sectionEl.videoGridSyncPlayback === 'function') {
        sectionEl.videoGridSyncPlayback();
      }
    });
  }

  function bootstrap(root) {
    (root || document).querySelectorAll('[data-video-grid-section]').forEach(function (sectionEl) {
      initVideoGridSection(sectionEl);
      initVideoGridSwiper(sectionEl);
    });
  }

  function start() {
    if (typeof Swiper === 'undefined') {
      window.setTimeout(start, 50);
      return;
    }

    bootstrap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const sectionEl = event.target;
    if (!sectionEl || !sectionEl.hasAttribute('data-video-grid-section')) return;

    if (typeof sectionEl.videoGridDestroy === 'function') {
      sectionEl.videoGridDestroy();
    }

    const swiperEl = sectionEl.querySelector('.video-grid-swiper');
    if (swiperEl) {
      if (swiperEl.swiper && typeof swiperEl.swiper.destroy === 'function') {
        swiperEl.swiper.destroy(true, true);
      }
      delete swiperEl.dataset.swiperInit;
    }

    bootstrap(sectionEl);
  });
})();
